var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"t-rr-s-hub-list"},[_c('Table',{attrs:{"data":_vm.listContent,"folderData":_vm.folderData},on:{"getpreviousfolder":_vm.getpreviousfolder}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }